import clsx from 'clsx'
import React from 'react'
import { PropsWithChildrenRequired } from '../../../types/PropsWithChildrenRequired'

type Props = {
    className?: string
}

export default function Cards({
    children,
    className,
}: PropsWithChildrenRequired<Props>): React.JSX.Element {
    const allClasses = clsx('w-full flex flex-col gap-2', className)

    return <div className={allClasses}>{children}</div>
}
